import React from 'react';

export default class extends React.Component {
    static propTypes = {
        children: React.PropTypes.any.isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                {this.props.children}
                <div className="modal--backdrop"></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/shared/components/ModalWindow.jsx